import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { checkTranslation, imageAddress } from '../../../../utils/useful'
import * as actions from '../../../../stores/actionsList';
import FixedView from '../../../FixedView'
import SwitchInput from '../../../inputs/SwitchInput'
import CustomLoader from '../../../CustomLoader';





class Members extends Component {
    state = {
        showCollapse: null,
        active: false,
        selected: 0,
        checkBox: {},
        show: false,

        Members: [
            { img: "/assets/icons/Group 237788.svg", name: "Sara Mohseni", state: "{{lang}}messenger.Online", role: "{{lang}}messenger.Owner" },
            { img: "/assets/icons/Group 237788.svg", name: "Sara Mohseni", state: "{{lang}}messenger.Online", role: "{{lang}}messenger.Owner" },
            { img: "/assets/icons/Group 237788.svg", name: "Sara Mohseni", state: "{{lang}}messenger.Online", role: "{{lang}}messenger.Owner" },
            { img: "/assets/icons/Group 237788.svg", name: "Sara Mohseni", state: "{{lang}}messenger.Online", role: "{{lang}}messenger.Owner" },
        ],

        option: [
            // { icon: "/assets/icons/manage-gray.svg", title: "Manage Group", color: "#444", key: "manage" },
            { icon: "/assets/icons/leave-red.svg", title: "{{lang}}messenger.Remove from group", color: "#E61515", key: "remove" },
        ]
    }



    // openSidebar = () => {
    //     this.sidebarView.openSidebar()
    // }

    // openFirstView = () => {
    //     this.firstView.showView()
    // }

    openMemberView = () => {
        this.memberView.showView()
    }


    render() {
        return (
            <div className='w-100'>
                <div className=''>
                    <div className='flexc w-100'>
                        <div>
                            <img className='br-50 flexcc' width={30} height={30} style={{ objectFit: "cover", aspectRatio: 1 }} src={imageAddress(this.props.data.img, 'profile',)} />
                        </div>
                        <div className='mld-3 w-100'>
                            <div className='flexcb w-100'>
                                <p className='font-size-12 ' style={{ color: "#555" }}>{checkTranslation(this.props.data.name)}</p>
                                <div className='flexc' >
                                    <p className='font-size-10 mrd-4' style={{ color: "#0085FF" }}>{checkTranslation(this.props.data.role)}</p>
                                    <button ref={el => this.memberNode = el} onClick={() => this.openMemberView()}>
                                        <img className='flexcc' width={22} src='/assets/icons/more-v-black.svg' />
                                    </button>
                                </div>
                            </div>
                            <div>
                                <p className='font-size-12 weight-300' style={{ color: "#999" }}>{checkTranslation(this.props.data.state)}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <FixedView ref={el => this.memberView = el} nodeRef={this.memberNode} showFocus={false} topOffset={-70} xOffset={150} width={190} zIndex={40} >
                    {/* {!this.props.isLoader ? ( */}
                    <div className='shadow-2 px-3 py-1 br-10 w-100' style={{ backgroundColor: "#fff" }}>
                        {this.state.option.map((prop, index) => {
                            return (
                                <div className='my-2' onClick={() => { prop.key == 'remove' && this.props.leaveGroup('removed', this.props.user) }}>
                                    <button className='flexc'>
                                        {this.props.isLoader ? (
                                            <div className='flexcc w-100 h-100'>
                                                <CustomLoader width={22} color={"#E61515"} isLoading={true} type={"Oval"} className='flexcc' />
                                            </div>
                                        ) : (
                                            <img width={22} src={prop.icon} />
                                        )}
                                        <p className='mld-2' style={{ color: prop.color }}>{checkTranslation(prop.title)}</p>
                                    </button>
                                </div>
                            )
                        })}
                    </div>
                    {/* ) : (

                        <div className='shadow-2 px-3 py-1 br-10' style={{ backgroundColor: "#fff", width: "max-Content" }}>
                            {this.state.option.map((prop, index) => {
                                return (
                                    <div className='my-2' onClick={() => { prop.key == 'remove' && this.props.leaveGroup('removed', this.props.user) }} >
                                        <button className='flexc'>
                                            <div className='flexcc'>
                                                <CustomLoader width={22} color={"#E61515"} isLoading={true} type={"Oval"} className='flexcc' />
                                            </div>
                                            <p className='mld-2' style={{ color: prop.color }}>{checkTranslation(prop.title)}</p>
                                        </button>
                                    </div>
                                )
                            })}
                        </div>
                    )} */}
                </FixedView>
            </div>
        )
    }
}

const mapStateToProps = state => ({ settings: state.settings })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Members);
